<template>
  <div id="app">
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
    <v-revert-changes-alert></v-revert-changes-alert>
  </div>
</template>
<script>
import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'
import Vue from 'vue'

import store from '~/store'
import {
  getRequireContext,
} from '../plugins/helper'

// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)
const layouts = getRequireContext(requireContext)
const { sentryUrl } = window.config
if (sentryUrl) {
  Sentry.init({
    dsn: sentryUrl,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  })
}

export default {
  el: '#app',
  metaInfo() {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`,
    }
  },
  data: () => ({
    layout: null,
    defaultLayout: 'default',
  }),
  errorCaptured(err, vm, info) {
    const { sentryUrl } = window.config
    if (sentryUrl && store.getters.authCheck && store.getters.authToken) {
      Sentry.configureScope(function(scope) {
        const { id, email, name } = store.getters.authUser
        scope.setUser({ id, email, username: name })
      })
      try {
        Sentry.captureException(err)
      } catch (e) {
        console.info(e)
      }
    }

    return false
  },
  methods: {
    /**
     * Set the application layout.
     * @param {String|null} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      if (layouts[layout][this.defaultLayout]) {
        this.layout = layouts[layout][this.defaultLayout]
      } else {
        this.layout = layouts[layout]
      }
    },
  },
}
</script>
